import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from '../../utils/storeUtils';

export const thunks = {
  getPieChatData: createThunk('chart/getPieChatData', () =>
    api.get(WEB_API_ROUTES.dashboard.list)
  ),
};
